import React from "react";
import TeamPageNav from "../../components/TeamPageNav/TeamPageNav";
import TeamMemberCard from "../../components/TeamMemberCard/TeamMemberCard";
import LisaCohen from "../../assets/team-members/lisa-cohen.jpg";
import KrisFloor from "../../assets/team-members/kris-floor.jpg";
import ToshaMcKee from "../../assets/team-members/tosha-mckee.jpg";
import AmandaBurke from "../../assets/team-members/amanda-burke.jpg";
import DanaPaschke from "../../assets/team-members/dana-paschke.jpg";
import DavidHanig from "../../assets/team-members/david-hanig.jpg";
import { sitePurple } from "../../providers/Theme";
import {
  PageSection,
  PageInner,
  PageHeading,
  PageSubtitle,
  MembersGrid,
  BackButton
} from "./styled.components";

interface Member {
  name: string;
  role: string;
  tenure: string;
  bio: string;
  photo?: string;
}

const members: Member[] = [
  {
    name: "Lisa Cohen",
    role: "Founder & CEO",
    tenure: "2019–Present",
    photo: LisaCohen,
    bio: "Lisa Cohen founded the Kyah Rayne Foundation in memory of her daughter, Kyah. Her background in marketing, public relations, promotions, and management shaped KRF's growth from a personal mission into a public health education nonprofit. Lisa leads the foundation's work in food allergy awareness, education, advocacy, and policy change."
  },
  {
    name: "Kris Floor",
    role: "Secretary",
    tenure: "2019–Present",
    photo: KrisFloor,
    bio: "Kris Floor is a landscape architect with a 40-year career focused on creating vibrant public spaces that support community health and connection. As a founding member and former Secretary of the Hance Park Conservancy, Kris brings governance experience, organizational leadership, and a strong commitment to mission-driven community impact."
  },
  {
    name: "Tosha McKee",
    role: "Treasurer",
    tenure: "2026–Present",
    photo: ToshaMcKee,
    bio: "Tosha McKee brings more than 20 years of nonprofit accounting experience and over 30 years in the accounting field. She is the Owner and Managing Member of TMK Accounting LLC and an IRS-licensed Enrolled Agent. As Treasurer, Tosha supports KRF's financial oversight, accountability, and long-term organizational sustainability."
  },
  {
    name: "Dr. Amanda Burke",
    role: "Board Member",
    tenure: "2019–Present",
    photo: AmandaBurke,
    bio: "Dr. Amanda Burke is Managing Director of Strategic Initiatives and Impact at the Center for the Future of Arizona. She brings expertise in education, workforce development, civic health, impact strategy, and systems change."
  },
  {
    name: "Dana Paschke",
    role: "Board Member",
    tenure: "2019–Present",
    photo: DanaPaschke,
    bio: "Dana Paschke brings nearly 20 years of experience in legislative affairs, government relations, strategic planning, and community relations. She supports KRF with policy insight, public-sector experience, and strategic guidance."
  },
  {
    name: "David Hanig",
    role: "Public Health Advisor",
    tenure: "2019–Present",
    photo: DavidHanig,
    bio: "David Hanig brings 40 years of experience in health care administration and health policy, including leadership with The Lewin Group, Washington State Senate health policy work, and senior Medicaid agency experience."
  }
];

const BoardOfDirectors: React.FC = () => (
  <>
    <TeamPageNav />
    <PageSection>
      <PageInner>
        <PageHeading $color={sitePurple}>Board of Directors</PageHeading>
        <PageSubtitle>
          KRF's Board provides strategic oversight and governance, ensuring the
          foundation fulfills its mission with integrity, transparency, and
          lasting impact.
        </PageSubtitle>
        <MembersGrid>
          {members.map(m => (
            <TeamMemberCard
              key={m.name}
              photo={m.photo}
              name={m.name}
              role={m.role}
              roleColor={sitePurple}
              subtitle={m.tenure}
              bio={m.bio}
            />
          ))}
        </MembersGrid>
        <BackButton
          to="/about-us/our-team"
          onClick={() => window.scrollTo(0, 0)}
        >
          Back to Our Team →
        </BackButton>
      </PageInner>
    </PageSection>
  </>
);

export default BoardOfDirectors;
